<ul class="controparti m0">
  <li class="{{soggetto.isAssociated ? 'unpanel' : 'panel'}}" *ngFor="let soggetto of soggetti; let indice = index">
    <div *ngIf="!soggetto.isAssociated" class="controparte">
      <div>
					<a
						href="#"
						role="button"
						class="{{activeIndex === indice ? 'accordion-collapse' : 'accordion-collapsed'}} mt-toggle"
						[class.accordion-collapse]="activeIndex === indice"
						[class.accordion-collapsed]="activeIndex !== indice"
						[attr.aria-expanded]="activeIndex === indice"
						id="accordion-header-sogg-{{indice}}"
						(click)="openDetail(soggetto, indice); $event.preventDefault()">
							<span aria-live="polite" class="sr-only">{{ activeIndex === indice ? 'Chiudi dettaglio' : 'Apri dettaglio' }}</span>
					</a>
        <p class="col-sm-2 button-associa" *ngIf="activeIndex != indice">
          <button [disabled]="!soggetto.isAssociable" class="btn btn-primary associa"
            (click)="associa(soggetto.option, indice)">Associa</button>
        </p>
        <p class="titolo col-sm-3 mt-5"
          *ngIf="soggetto.option.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
            {{soggetto.option.parte.cognome}} {{soggetto.option.parte.nome}}
        </p>
        <p class="titolo col-sm-3 mt-5"
          *ngIf="soggetto.option.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
            {{soggetto.option.parte.ragioneSociale}}
        </p>
        <p class="col-sm-3 matricola mt-5"
          *ngIf="soggetto.option.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
          C/F: <strong>{{soggetto.option.parte.codiceFiscale}}</strong>
        </p>
        <p class="col-sm-3 matricola mt-5"
          *ngIf="soggetto.option.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
          P.IVA: <strong>{{soggetto.option.parte.partitaIva}}</strong>
        </p>
        <p class="col-sm-2 matricola mt-5" *ngIf="soggetto.option.parte.id?.startsWith('TEMP')">
          <span class="label label-success">Nuova anagrafica</span>
        </p>
        <p class="col-sm-2 matricola mt-5" *ngIf="!soggetto.isAssociable">
          <span class="label label-danger">Da completare</span>
        </p>

      </div>
    </div>
    <ul class="{{activeIndex === indice ? 'collapsed' : 'collapse'}} subcontroparte">

      <li *ngIf="parteSelected && associationParte && associable">
        <div class="container_dati_generali">
          <step-soggetti-terzi-form-associativa [parte]="parteSelected.parte"
            (altraParteChange)="retrieveAltraParte($event)" [suggestedCategory] = "soggetto.categoria"></step-soggetti-terzi-form-associativa>
        </div>
      </li>

      <li *ngIf="parteSelected && editingParte">
        <div class="container_dati_generali">
          <anagrafica-parte-form [hasDetailsAnagrafica]="soggetto.hasDetailsAnagrafica" *ngIf="parteSelected === soggetto.option" [parte]="parteSelected.parte"
            (parteChange)="retrieveParte($event , soggetto )" [labelButton]="'Modifica'" [editing]="editingParte"></anagrafica-parte-form>
        </div>
      </li>

      <li *ngIf="!parteSelected && !editingParte">
        <div class="container_dati_generali">
          <div class="container_tab_nav" *ngIf="soggetto.option.categoriaAltraParte != null">
            <ul class="nav nav-tabs two">
              <li (click)="setTab('ASSOCIATIVA')"
              class="{{currentTab === 'ASSOCIATIVA' ? 'active' : 'inactive'}}">
                <a>Associativa</a>
              </li>
              <li (click)="setTab('ANAGRAFICA')"
              class="{{currentTab === 'ANAGRAFICA' ? 'active' : 'inactive'}}">
                <a>Anagrafica</a>
              </li>
            </ul>
          </div>
          <div *ngIf="currentTab == 'ASSOCIATIVA'">
            <div class="row">
              <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Categoria'"
                [valueInput]="soggetto.option.categoriaAltraParte?.label"></div>
            </div>
            <div class="row">
              <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Rinunciatario'"
                [valueInput]="soggetto.option.ritirato ? 'Sì' : 'No'"></div>
              <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'date'" [labelInput]="'Data Rinuncia'"
                [valueInput]="soggetto.option.dataTermine"></div>
            </div>
            <div class="row">
              <div labelTextInput class="col-sm-12 bloccodati" [typeLabel]="'text'" [labelInput]="'Note'"
                [valueInput]="soggetto.option.note"></div>
            </div>
          </div>
          <div *ngIf="currentTab == 'ANAGRAFICA'">
            <app-dati-generali-anagrafiche-search  [option]="{ hasDetailsAnagrafica: false, anagrafica: soggetto.option.parte}"
						[isLegale]="isLegale" [isPartiSearch]="true" [isControparte]="isControparte"></app-dati-generali-anagrafiche-search>
          </div>
        </div>
      </li>
      <p class="col-sm-3 col-sm-offset-9 col-xs-3 col-xs-offset-9">
        <button *ngIf="!parteSelected" type="button" class="btn btn-primary btn-block"
          (click)="modificaDati(soggetto.option)">Modifica
          dati</button>
      </p>
    </ul>
  </li>
  <div *ngIf="soggetti.length > 0" class="standardpanel">
    <div class="row allinea_centro col-sm-12">
      <button *ngIf="totali > soggetti.length" type="button" class="btn-link" (click)="requestMore.emit()">
        <strong>Carica altri risultati</strong>
      </button>

      <div>
        <strong *ngIf="totali > soggetti.length">
          Risultati {{soggetti.length}} di {{totali}}
        </strong>
        <strong *ngIf="totali <= soggetti.length">
          Risultati totali {{totali}}
        </strong>
      </div>
    </div>
  </div>
</ul>
